import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=b468a948&scoped=true&"
import script from "CY/components/home/DownloadCenter.component?vue&type=script&lang=js&"
export * from "CY/components/home/DownloadCenter.component?vue&type=script&lang=js&"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=b468a948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b468a948",
  null
  
)

export default component.exports